"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _layout = _interopRequireDefault(require("./layout"));

var _MessageEditor = require("../MessageEditor");

var MessageItemContainer = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(MessageItemContainer, _Component);

  var _super = (0, _createSuper2["default"])(MessageItemContainer);

  function MessageItemContainer(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, MessageItemContainer);
    _this = _super.call(this, props);

    _this.onLoadMoreComments = function () {
      var numberOfShownComments = _this.props.numberOfShownComments;

      _this.setState(function (prevState) {
        return {
          numberOfShownComments: prevState.numberOfShownComments + numberOfShownComments
        };
      });
    };

    _this.getAttachmentsByMediaTypes = function (mediaTypes) {
      var attachments = _this.props.attachments;

      if (!attachments) {
        return [];
      }

      return attachments.filter(function (attachment) {
        return mediaTypes.includes(attachment.type);
      });
    };

    _this.state = {
      numberOfShownComments: props.numberOfShownComments
    };
    return _this;
  }

  (0, _createClass2["default"])(MessageItemContainer, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_layout["default"], Object.assign({}, this.props, this.state, {
        onLoadMoreComments: this.onLoadMoreComments,
        onToggleMenu: this.onToggleMenu,
        imagesAndVideos: this.getAttachmentsByMediaTypes([_MessageEditor.MESSAGE_MEDIA_TYPES.IMAGE, _MessageEditor.MESSAGE_MEDIA_TYPES.VIDEO]),
        links: this.getAttachmentsByMediaTypes([_MessageEditor.MESSAGE_MEDIA_TYPES.LINK]),
        pdfs: this.getAttachmentsByMediaTypes([_MessageEditor.MESSAGE_MEDIA_TYPES.PDF])
      }));
    }
  }]);
  return MessageItemContainer;
}(_react.Component);

MessageItemContainer.defaultProps = {
  numberOfShownComments: 5,
  attachments: null
};
var _default = MessageItemContainer;
exports["default"] = _default;